import { render, staticRenderFns } from "./AttractionUniqnes.vue?vue&type=template&id=3b9a7ed2&scoped=true"
import script from "./AttractionUniqnes.vue?vue&type=script&lang=js"
export * from "./AttractionUniqnes.vue?vue&type=script&lang=js"
import style0 from "./AttractionUniqnes.vue?vue&type=style&index=0&id=3b9a7ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9a7ed2",
  null
  
)

export default component.exports